import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useAccessControl } from "@/hooks/useAccessControl";
import { FeatureList } from "./FeatureList";

interface AccessControlDialogProps {
  isOpen: boolean;
  onClose: () => void;
  userId: string;
}

export const AccessControlDialog = ({
  isOpen,
  onClose,
  userId,
}: AccessControlDialogProps) => {
  const {
    selectedFeatures,
    setSelectedFeatures,
    isLoading,
    handleSubmit,
  } = useAccessControl(userId, isOpen);

  const onSubmit = async (e: React.FormEvent) => {
    const success = await handleSubmit(e);
    if (success) {
      onClose();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Gérer les accès</DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <FeatureList
            selectedFeatures={selectedFeatures}
            onFeatureChange={setSelectedFeatures}
          />
          <Button type="submit" className="w-full" disabled={isLoading}>
            {isLoading ? "Mise à jour..." : "Mettre à jour les accès"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};